import React from 'react'
import {
  Button,
  TableRow,
  TableCell,
  Table,
  TableBody,
  MenuItem,
  withStyles
} from '@material-ui/core'
import { Form, Field } from '../../form'
import { createYearItems } from '../../utils/admin.utils'
import IconTooltip from '../../utils/IconTooltip'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4),
    width: '100%'
  },
  tableCell: {
    border: 'none',
    padding: '8px 10px'
  },
  checkbox: {
    fontSize: '13px',
    padding: '0px 4px',
    margin: '0px'
  },
  select: {
    fontSize: '15px',
    padding: '4px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  }
})

class AdminSalaryFilterRow extends React.Component {
  render() {
    return <AdminSalaryFilterRowComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminSalaryFilterRow)

const AdminSalaryFilterRowComponent = ({ classes, form }) => {
  const { control, setValue } = form

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="salaryId"
                label="Palkatunnus"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="firstname"
                label="Käyttäjänimi"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="socialID"
                label="Henkilötunnus"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="email"
                label="Sähköposti"
                style={{ width: '100%' }}
                inputType="textfield"
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell} style={{ width: '150px' }}>
              <Field
                control={control}
                name="has_yel"
                label="YEL"
                inputType="checkbox"
                className={classes.checkbox}
              />
              <div style={{ display: 'flex' }}>
                <Field
                  control={control}
                  name="has_ulosotto"
                  label="Ulosotto"
                  inputType="checkbox"
                  className={classes.checkbox}
                />
                <IconTooltip
                  tooltipShow={
                    <span>
                      {'(M) Manuaalinen Ulosotto'}
                      <br />
                      {'(N) Normaali Ulosotto'}
                      <br /> 
                      {'(B) Brutto Ulosotto '}
                    </span>
                  }
                />
              </div>
              <Field
                control={control}
                name="is_Pplasku"
                label="Pplasku"
                inputType="checkbox"
                className={classes.checkbox}
              />
            </TableCell>
            <TableCell className={classes.tableCell}></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="start_date"
                inputType="datepicker"
                label="Alkupvm"
                textFieldStyle={{ width: '100%' }}
                onChange={() => setValue('yearSelect', '')}
                className={classes.textField}
                clearable
                onClear={() => setValue('start_date', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="end_date"
                inputType="datepicker"
                label="Loppupvm"
                textFieldStyle={{ width: '100%' }}
                onChange={() => setValue('yearSelect', '')}
                className={classes.textField}
                clearable
                onClear={() => setValue('end_date', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="status"
                label="Tila"
                inputType="select"
                control={control}
                className={classes.select}
              >
                <MenuItem value={''}>Kaikki</MenuItem>
                <MenuItem value={'processing'}>Käsittelyssä</MenuItem>
                <MenuItem value={'paid'}>Maksettu</MenuItem>
                <MenuItem value={'BankingInitiation'}>
                  Pankkikäynnistys
                </MenuItem>
                <MenuItem value={'bankingprocess'}>
                  Pankin käsittelyssä
                </MenuItem>
                <MenuItem value={'bankreject'}>Pankki hylännyt</MenuItem>
                <MenuItem value={'bankaccept'}>Pankki hyväksynyt</MenuItem>
                <MenuItem value={'IRValid'}>TR hyväksynyt</MenuItem>
                <MenuItem value={'IRManual'}>TR manuaalinen</MenuItem>
                <MenuItem value={'IRRejected'}>TR hylätty</MenuItem>
                <MenuItem value={'IRCancelled'}>TR peruttu</MenuItem>
                <MenuItem value={'IRRejectCancelled'}>
                  TR hylkäys peruttu
                </MenuItem>
                <MenuItem value={'IRinitiated'}>TR aloitus</MenuItem>
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="yelSelect"
                inputType="select"
                label="YEL-status"
                className={classes.select}
              >
                <MenuItem value={''}>Kaikki</MenuItem>
                <MenuItem value={'no_yel'}>
                  En ole YEL-vakuutusvelvollinen
                </MenuItem>
                <MenuItem value={'yel_self'}>
                  Maksan YEL-vakuutuksen itse
                </MenuItem>
                <MenuItem value={'yel_minimum'}>
                  Maksan minimi YEL-vakuutuksen (9010,28 €)
                </MenuItem>
                <MenuItem value={'yel_recommended'}>
                  Maksetaan YEL-vakuutus tulojen mukaan 24,10 %
                </MenuItem>
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="yearSelect"
                inputType="select"
                className={classes.select}
                label="Valitse vuosi"
                onChange={(event) => {
                  if (event.target.value === '') {
                    setValue('start_date', null)
                    setValue('end_date', null)
                  }
                }}
              >
                <MenuItem value={''}>Kaikki</MenuItem>
                {createYearItems()}
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                control={control}
                name="adminSalaryPageSize"
                inputType="select"
                label="Näytetään"
                className={classes.select}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Field>
            </TableCell>
            <TableCell className={classes.tableCell}></TableCell>
            <TableCell className={classes.tableCell}>
              <Button
                className="pull-right"
                type="submit"
                variant="contained"
                style={{ width: '80px', marginTop: '36px' }}
              >
                HAE
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
